const r = (n) => ({
  width: (t) => n.map((e) => e === null ? e : e === 0 ? "100%" : `calc(100% + ${t.spacing(e * 2)})`),
  ml: (t) => n.map((e) => e === null ? e : t.spacing(-e))
}), l = (n, t) => ({
  "&:first-of-type": {
    ml: n
  },
  "&:last-of-type": {
    position: "relative",
    "::before": {
      content: '""',
      width: t ?? n,
      height: (e) => e.spacing(0.25),
      position: "absolute",
      left: "100%",
      top: 0
    }
  }
});
export {
  r as expandElementOverOffset,
  l as scrollableFlexEdgeElementMargins
};
